export const extractErrorMessage = (error: any, fallback = "Something went wrong") => {
  return error.response?.data?.errors?.join(". ") ?? fallback;
};

export const attemptsWarning = (error: any): string | null => {
  const remaining = error?.response?.data?.attempts_remaining;
  if (remaining == null) return null;
  if (remaining === 0) return "Too many failed attempts. Your account is locked for one hour.";
  return `${remaining} ${remaining === 1 ? "attempt" : "attempts"} remaining. After that, your account is locked for one hour.`;
};
